import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import useBoundStore from 'store';

const EstimateScreensWrapper: React.FC = () => {
  const isAuth = useBoundStore.getState().authToken;

  useEffect(() => {
    if (!isAuth) {
      useBoundStore.getState().openAuthBottomSheet();
    }
  }, []);

  return <Outlet />;
};

export default EstimateScreensWrapper;
